import axios from 'axios';
import { config } from '../../config';
import { adminAuthHeaders } from './authHeaders';

export async function getAdminVideoLinks(params = {}) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.get(`${host}/video-links`, {
        params,
        headers,
    });
    return data;
}
